export const blockIconsTravelMuseumNew = (
	<span className='material-symbols-outlined'>museum</span>
);
